import Link from 'next/link'

import { styled } from '@mui/material'

export const StyledBreadcrumbLink = styled(Link)`
  color: ${(props) => props.theme.palette.text.secondary};
  font-weight: 300;
  font-size: ${(props) => props.theme.typography.pxToRem(14)};
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.palette.text.primary};
    text-decoration: underline;
    text-decoration-color: ${(props) => props.theme.palette.text.primary};
  }
`
